export default __webpack_public_path__ + "static/media/email.d5f38cf9.svg";